document.addEventListener("DOMContentLoaded", function () {
  const toggleBtn = document.getElementById('toggle-unit');
  const cmTable = document.getElementById('table-cm');
  const inTable = document.getElementById('table-inches');

  if (toggleBtn && cmTable && inTable) {
    cmTable.style.display = 'none';
    inTable.style.display = 'block';
    toggleBtn.textContent = 'Afficher en centimètres (cm)';

    toggleBtn.addEventListener('click', () => {
      const showingCm = cmTable.style.display !== 'none';
      cmTable.style.display = showingCm ? 'none' : 'block';
      inTable.style.display = showingCm ? 'block' : 'none';
      toggleBtn.textContent = showingCm
        ? 'Afficher en centimètres (cm)'
        : 'Afficher en pouces (po)';
    });
  }
});